import { api, ApiEnvelope } from "../../api/client";

export interface PiListRow {
  SNO: number; ID: number; Processor: string; PInvNumber: string; PInvDate: string;
  PoNo: string; Buyer: string; ShipByDate: string; Status: string;
}
export interface BuyerRow { SNO: number; BuyerName: string; BuyerAddress: string; Country: string | null; BuyerEmailAddress: string; }
export interface ConsigneeRow { SNO: number; ConsigneeName: string; ConsigneeAddress: string; Country: string | null; EmailAddress: string; }
export interface BankRow {
  SNO: number; ID: number; AccountName: string; AccountNumber: string; BankName: string; BankAddress: string;
  SwiftCode: string; ABANumber: string; BankDetails: string; RoutingThrough: string; NegotiatingBank: string;
}
export interface ClearingAgentRow { SNO: number; InvNo: string; ID: number; Buyer: string; BLNo: string; PortOfDischarge: string; NotifypartyName: string | null; }

export const salesApi = {
  piList: async (p: Record<string, unknown> = {}) =>
    (await api.get<ApiEnvelope<PiListRow[]> & { TotalCount: number; PageCount: number; RecordsAval: number }>("/sales/pi-list", { params: p })).data,
  buyers: async () => (await api.get<ApiEnvelope<BuyerRow[]>>("/sales/buyers")).data,
  consignees: async () => (await api.get<ApiEnvelope<ConsigneeRow[]>>("/sales/consignees")).data,
  banks: async () => (await api.get<ApiEnvelope<BankRow[]>>("/sales/banks")).data,
  clearingAgentStatus: async (p: { FromDate: string; ToDate: string; CountryID?: string; Status?: string; SearchKey?: string }) =>
    (await api.get<ApiEnvelope<ClearingAgentRow[]> & { TotalCount: number }>("/sales/clearing-agent-status", { params: p })).data,
};
